// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")
const jQuery = require("jquery");

global.$ = global.jQuery = jQuery;
window.$ = window.jQuery = jQuery;


require("bootstrap")
require('datatables.net-bs4')
require("tables/dataTables.select")
require("tables/dataTables.colReorder")

require("packs/participation_mgmt")
require("packs/reload_label_button")
require("tables/staff_data-table");
require("tables/new_staff_data-table");
require("tables/exams_data-table");
require("tables/archive_data-table");

// Toastr flash messages
global.toastr = require("toastr")

import "../stylesheets/application"
import "@fortawesome/fontawesome-free/js/all";

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
